import React from "react";
import { Route, Navigate, RouteProps, useParams } from "react-router-dom";

// components
import PrivateRoute from "./PrivateRoute";
// import Root from './Root';

// lazy load all the views

// auth
const Login = React.lazy(() => import("../pages/auth/Login"));
const Logout = React.lazy(() => import("../pages/auth/Logout"));
const Confirm = React.lazy(() => import("../pages/auth/Confirm"));
const ForgetPassword = React.lazy(() => import("../pages/auth/ForgetPassword"));
const Register = React.lazy(() => import("../pages/auth/Register"));
const SignInSignUp = React.lazy(() => import("../pages/auth/SignInSignUp"));
const LockScreen = React.lazy(() => import("../pages/auth/LockScreen"));
const ResetTempPassword = React.lazy(() => import("../pages/auth/ResetTempPassword"));
const ChangePassword = React.lazy(() => import("../pages/auth/ChangePassword"));

// auth2
// const Login2 = React.lazy(() => import("../pages/auth2/Login2"));
// const Logout2 = React.lazy(() => import("../pages/auth2/Logout2"));
// const Register2 = React.lazy(() => import("../pages/auth2/Register2"));
// const Confirm2 = React.lazy(() => import("../pages/auth2/Confirm2"));
// const ForgetPassword2 = React.lazy(
//   () => import("../pages/auth2/ForgetPassword2")
// );
// const LockScreen2 = React.lazy(() => import("../pages/auth2/LockScreen2"));
// const SignInSignUp2 = React.lazy(() => import("../pages/auth2/SignInSignUp2"));

// // landing
// const Landing = React.lazy(() => import("../pages/landing/"));

// dashboard
const Dashboard1 = React.lazy(() => import("../pages/dashboard/Dashboard1/"));
const Dashboard2 = React.lazy(() => import("../pages/dashboard/Dashboard2/"));
const Dashboard3 = React.lazy(() => import("../pages/dashboard/Dashboard3/"));
const Dashboard4 = React.lazy(() => import("../pages/dashboard/Dashboard4/"));

// apps
// const CalendarApp = React.lazy(() => import("../pages/apps/Calendar/"));
// const Projects = React.lazy(() => import("../pages/apps/Projects/"));
// const ProjectDetail = React.lazy(
//   () => import("../pages/apps/Projects/Detail/")
// );
// const ProjectForm = React.lazy(
//   () => import("../pages/apps/Projects/ProjectForm")
// );
// - chat
const ChatApp = React.lazy(() => import("../pages/apps/Chat/"));
const ChatHub = React.lazy(() => import("../pages/apps/Chathub/"));
const Compliancereport = React.lazy(() => import("../pages/apps/Compliance/"));
const DemoChat = React.lazy(() => import("../pages/apps/Chat/DemoIndex"));
//const ChatHistory = React.lazy(() => import("../pages/apps/Chat/ChatHistory"));
const ChathubHistorySearch = React.lazy(()=> import ("../../src/components/ChathubHistorySearch"));

// Shared Chat View - PUBLIC ROUTE
const SharedChatView = React.lazy(() => import("../pages/apps/Chathub/component/SharedChatView"));
const SharedFolderView = React.lazy(() => import("../pages/apps/Chathub/component/SharedFolderView"));
const SharedWorksapceView = React.lazy(() => import("../pages/apps/Chathub/component/SharedWorkspaceView"));

// - Presentation
const PresentationApp = React.lazy(() => import("../pages/apps/presentation"));

// - GPT
const GptApp = React.lazy(() => import("../pages/apps/LLM/"));

//- Settings
const ApprovedApps = React.lazy(() => import("../pages/apps/Settings/ApprovedApps"));
const NotificationPreferences = React.lazy(() =>import("../pages/apps/Settings/NotificationPreferences"));

//-keycloak groups
const KeycloakGroups = React.lazy(() => import("../keycloakGroups"));
const KeycloakUser = React.lazy(() => import("../keycloakUser"));
const KeycloakUserDetails = React.lazy(() => import("../keycloakUserDetails"));
const KeycloakUserDetailsWrapper = () => {
  const { userId } = useParams();

  if (!userId) {
    // Redirect or handle missing userId case
    return <Navigate to="/settings/users" />;
  }

  return <KeycloakUserDetails userId={userId} />;
};

// Import your drilldown views at the top of index.tsx
const BlockedRequestsView = React.lazy(() => import("../components/Dashboard/DrilldownViews/BlockedRequestsView"));
const ModifiedResponsesView = React.lazy(() => import("../components/Dashboard/DrilldownViews/ModifiedResponsesView"));
const HighRiskActivitiesView = React.lazy(() => import("../components/Dashboard/DrilldownViews/HighRiskActivitiesView"));
const UserSecurityProfileView = React.lazy(() => import("../components/Dashboard/DrilldownViews/UserSecurityProfileView"));
const SessionActivityView = React.lazy(() => import("../components/Dashboard/DrilldownViews/SessionActivityView"));
const ValidationDetailsView = React.lazy(() => import("../components/Dashboard/DrilldownViews/ValidationDetailsView"));
const ActivityDetailView = React.lazy(() => import("../components/Dashboard/DrilldownViews/ActivityDetailView"));
const SecurityDashboard = React.lazy(() => import("../pages/dashboard/Dashboard1/SecurityDashboard"));

// - Connectors
const SnowflakeForm = React.lazy(() => import("../pages/apps/Companies/SnowflakeSetupForm"));
const PostgresqlForm = React.lazy(() => import("../pages/apps/Companies/Postgresql"));
const SQLliteForm = React.lazy(() => import("../pages/apps/Companies/sqlliteform"));
const BigqueryForm = React.lazy(() => import("../pages/apps/Companies/BigQuery"));
const SqlserverForm = React.lazy(() => import("../pages/apps/Companies/sqlserverform"));
const MysqlForm = React.lazy(() => import("../pages/apps/Companies/mysqlform"));
const MongodbForm = React.lazy(() => import("../pages/apps/Companies/Mongodbform"));
const MicrosoftgraphForm = React.lazy(() => import("../pages/apps/Companies/MicrosoftGraph"));
// - Dataset
const ConnectdbApp = React.lazy(() => import("../pages/apps/Database/"));
const Activedataset = React.lazy(() => import("../pages/apps/Dataset/"));
const Metadataapp = React.lazy(() => import("../pages/apps/Dataset/metadata"));
//- My Insight
const MyInsightApp = React.lazy(() => import("../pages/apps/MyInsight/"));
//- Scheduled Tasks
const ScheduledTasksApp = React.lazy(() => import("../pages/apps/scheduletasks/index"));
//- Models
const ModelsApp = React.lazy(() => import("../pages/apps/LLM/ProviderModels"));
//- AI Security
const AISecurityApp = React.lazy(() => import("../pages/apps/AISecurity/"));
// - Insight
const InsightApp = React.lazy(() => import("../pages/apps/Insights/"));
const Aiagentapp = React.lazy(() => import("../pages/apps/Chat/AgentCrud"));
// - Billing
const BillingApp = React.lazy(() => import("../pages/apps/Billing/"));
// - AIReady
const AIreadyApp = React.lazy(() => import("../pages/apps/AIready/"));
const CategoryDetailView = React.lazy(() => import("../pages/apps/AIready/CategoryDetailView"));
const TableDetailView = React.lazy(() => import("../pages/apps/AIready/TableDetailView"));
const RecommendationsView = React.lazy(() => import("../pages/apps/AIready/RecommendationsView"));
const ExecutiveSummaryView = React.lazy(() => import("../pages/apps/AIready/ExecutiveSummaryView"));
const Aireadydatasetapp = React.lazy(() => import("../pages/apps/AIready/AIreadydetails"));
const AireadyTemplates = React.lazy(() => import("../pages/apps/AIready/Templates"));
// - DataCatalog
const DataCatalogApp = React.lazy(() => import("../pages/apps/DataCatalog/"));
const ClassificationApp = React.lazy(() => import("../pages/apps/DataCatalog/admin/classification"));
const PersonasApp = React.lazy(() => import("../pages/apps/DataCatalog/admin/Personas"));
const DomainApp = React.lazy(() => import("../pages/apps/DataCatalog/admin/DomainManagement"));
const DomainDetailsapp = React.lazy(() => import("../pages/apps/DataCatalog/admin/DomainDetails"));
const GlossaryApp = React.lazy(() => import("../pages/apps/DataCatalog/admin/Glossary"));
const DatacatalogMetadataapp = React.lazy(() => import("../pages/apps/DataCatalog/datacatalog-metadata"));
const QuestionApp = React.lazy(() => import("../pages/apps/DataCatalog/admin/QuestionManagement"));
// - RangerPolicy
const RangerpolicyApp = React.lazy(() => import("../pages/apps/DataCatalog/Rangerpolicy"));
// - DataQuality
const DataqualityApp = React.lazy(() => import("../pages/apps/DataQuality/"));
const DataqualityruleApp = React.lazy(() => import("../pages/apps/DataQuality/DataRules"));
const DqruleApp = React.lazy(() => import("../pages/apps/DataQuality/DataRulesTable"));
const DqrulelogApp = React.lazy(() => import("../pages/apps/DataQuality/Ruleruns"));
// - companies
const Companies = React.lazy(() => import("../pages/apps/Companies/"));
// - ecommece pages
// const EcommerceDashboard = React.lazy(
//   () => import("../pages/apps/Ecommerce/Dashboard/")
// );
// const EcommerceProducts = React.lazy(
//   () => import("../pages/apps/Ecommerce/Products")
// );
// const ProductDetails = React.lazy(
//   () => import("../pages/apps/Ecommerce/ProductDetails")
// );
// const ProductEdit = React.lazy(
//   () => import("../pages/apps/Ecommerce/ProductEdit")
// );
// const Customers = React.lazy(() => import("../pages/apps/Ecommerce/Customers"));
// const Orders = React.lazy(() => import("../pages/apps/Ecommerce/Orders"));
// const OrderDetails = React.lazy(
//   () => import("../pages/apps/Ecommerce/OrderDetails")
// );
// const Sellers = React.lazy(() => import("../pages/apps/Ecommerce/Sellers"));
// const Cart = React.lazy(() => import("../pages/apps/Ecommerce/Cart"));
// const Checkout = React.lazy(() => import("../pages/apps/Ecommerce/Checkout"));
// // - crm pages
// const CRMDashboard = React.lazy(() => import("../pages/apps/CRM/Dashboard/"));
// const CRMContacts = React.lazy(() => import("../pages/apps/CRM/Contacts/"));
// const Opportunities = React.lazy(
//   () => import("../pages/apps/CRM/Opportunities/")
// );
// const CRMLeads = React.lazy(() => import("../pages/apps/CRM/Leads/"));
// const CRMCustomers = React.lazy(() => import("../pages/apps/CRM/Customers/"));
// // - email
// const Inbox = React.lazy(() => import("../pages/apps/Email/Inbox"));
// const EmailDetail = React.lazy(() => import("../pages/apps/Email/Detail"));
// const EmailCompose = React.lazy(() => import("../pages/apps/Email/Compose"));
// // - social
// const SocialFeed = React.lazy(() => import("../pages/apps/SocialFeed/"));

// - tasks
// const TaskList = React.lazy(() => import("../pages/apps/Tasks/List/"));
// const TaskDetails = React.lazy(() => import("../pages/apps/Tasks/Details"));
// const Kanban = React.lazy(() => import("../pages/apps/Tasks/Board/"));
// // -contacts
// const ContactsList = React.lazy(() => import("../pages/apps/Contacts/List/"));
// const ContactsProfile = React.lazy(
//   () => import("../pages/apps/Contacts/Profile/")
// );
// // -tickets
// const TicketsList = React.lazy(() => import("../pages/apps/Tickets/List/"));
// const TicketsDetails = React.lazy(
//   () => import("../pages/apps/Tickets/Details/")
// );
// // - file
// const FileManager = React.lazy(() => import("../pages/apps/FileManager"));

// // extra pages
// const Starter = React.lazy(() => import("../pages/other/Starter"));
// const Timeline = React.lazy(() => import("../pages/other/Timeline"));
// const Sitemap = React.lazy(() => import("../pages/other/Sitemap/"));
const Error404 = React.lazy(() => import("../pages/error/Error404"));
const Error404Two = React.lazy(() => import("../pages/error/Error404Two"));
const Error404Alt = React.lazy(() => import("../pages/error/Error404Alt"));
const Error500 = React.lazy(() => import("../pages/error/Error500"));
const Error500Two = React.lazy(() => import("../pages/error/Error500Two"));
// - other
// const Invoice = React.lazy(() => import("../pages/other/Invoice"));
// const FAQ = React.lazy(() => import("../pages/other/FAQ"));
// const SearchResults = React.lazy(() => import("../pages/other/SearchResults/"));
// const Upcoming = React.lazy(() => import("../pages/other/Upcoming"));
// const Pricing = React.lazy(() => import("../pages/other/Pricing"));
// const Gallery = React.lazy(() => import("../pages/other/Gallery/"));
// const Maintenance = React.lazy(() => import("../pages/other/Maintenance"));

// uikit
// const Buttons = React.lazy(() => import("../pages/uikit/Buttons"));
// const Avatars = React.lazy(() => import("../pages/uikit/Avatars"));
// const Cards = React.lazy(() => import("../pages/uikit/Cards"));
// const Portlets = React.lazy(() => import("../pages/uikit/Portlets"));
// const TabsAccordions = React.lazy(
//   () => import("../pages/uikit/TabsAccordions")
// );
// const Progress = React.lazy(() => import("../pages/uikit/Progress"));
// const Modals = React.lazy(() => import("../pages/uikit/Modals"));
// const Notifications = React.lazy(() => import("../pages/uikit/Notifications"));
// const Offcanvases = React.lazy(() => import("../pages/uikit/Offcanvas"));
// const Placeholders = React.lazy(() => import("../pages/uikit/Placeholders"));
// const Spinners = React.lazy(() => import("../pages/uikit/Spinners"));
// const Images = React.lazy(() => import("../pages/uikit/Images"));
// const Carousels = React.lazy(() => import("../pages/uikit/Carousel"));
// const ListGroups = React.lazy(() => import("../pages/uikit/ListGroups"));
// const EmbedVideo = React.lazy(() => import("../pages/uikit/EmbedVideo"));
// const Dropdowns = React.lazy(() => import("../pages/uikit/Dropdowns"));
// const Ribbons = React.lazy(() => import("../pages/uikit/Ribbons"));
// const TooltipsPopovers = React.lazy(
//   () => import("../pages/uikit/TooltipsPopovers")
// );
// const GeneralUI = React.lazy(() => import("../pages/uikit/GeneralUI"));
// const Typography = React.lazy(() => import("../pages/uikit/Typography"));
// const Grid = React.lazy(() => import("../pages/uikit/Grid"));
// const NestableList = React.lazy(() => import("../pages/uikit/NestableList"));
// const DragDrop = React.lazy(() => import("../pages/uikit/DragDrop"));
// const RangeSliders = React.lazy(() => import("../pages/uikit/RangeSliders"));
// const Animation = React.lazy(() => import("../pages/uikit/Animation"));
// const TourPage = React.lazy(() => import("../pages/uikit/TourPage"));
// const SweetAlerts = React.lazy(() => import("../pages/uikit/SweetAlerts"));
// const LoadingButtons = React.lazy(
//   () => import("../pages/uikit/LoadingButtons")
// );

// // widgets
// const Widgets = React.lazy(() => import("../pages/uikit/Widgets"));

// // icons
// const TwoToneIcons = React.lazy(() => import("../pages/icons/TwoToneIcons/"));
// const FeatherIcons = React.lazy(() => import("../pages/icons/FeatherIcons/"));
// const Dripicons = React.lazy(() => import("../pages/icons/Dripicons/"));
// const MDIIcons = React.lazy(() => import("../pages/icons/MDIIcons/"));
// const FontAwesomeIcons = React.lazy(
//   () => import("../pages/icons/FontAwesomeIcons/")
// );
// const ThemifyIcons = React.lazy(() => import("../pages/icons/ThemifyIcons/"));
// const SimpleLineIcons = React.lazy(
//   () => import("../pages/icons/SimpleLineIcons/")
// );
// const WeatherIcons = React.lazy(() => import("../pages/icons/WeatherIcons/"));



// // tables
// const BasicTables = React.lazy(() => import("../pages/tables/Basic"));
// const AdvancedTables = React.lazy(() => import("../pages/tables/Advanced"));

// // charts
// const ApexChart = React.lazy(() => import("../pages/charts/Apex"));
// const ChartJs = React.lazy(() => import("../pages/charts/ChartJs"));

// maps


export interface RoutesProps {
  path: RouteProps["path"];
  name?: string;
  element?: RouteProps["element"];
  route?: any;
  exact?: boolean;
  icon?: string;
  header?: string;
  roles?: string[];
  children?: RoutesProps[];
}

// root routes
const rootRoute: RoutesProps = {
    path: '/',
    exact: true,
     element: <Navigate to="/apps/chathub" />,
    route: Route,
};

// dashboards
const dashboardRoutes: RoutesProps = {
  path: "/dashboard",
  name: "Dashboards",
  icon: "airplay",
  header: "Navigation",
  children: [
    // {
    //   path: "/",
    //   name: "Root",
    //   element: <Navigate to="/dashboard-1" />,
    //   route: PrivateRoute,
    // },
    {
      path: "/dashboard-1",
      name: "Dashboard 1",
      element: <Dashboard1 />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard-2",
      name: "Dashboard 2",
      element: <Dashboard2 />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard-3",
      name: "Dashboard 3",
      element: <Dashboard3 />,
      route: PrivateRoute,
    },
    {
      path: "/dashboard-4",
      name: "Dashboard 4",
      element: <Dashboard4 />,
      route: PrivateRoute,
    },
  ],
};
// Then define security routes in the same format as your other routes
const securityRoutes = {
  path: "/security",
  name: "Security",
  icon: "shield",
  route: PrivateRoute,
  roles: ["Admin"],
  children: [
    {
      path: "/security",
      name: "Dashboard",
      element: <SecurityDashboard />,
      route: PrivateRoute,
    },
    {
      path: "/security/activities/:activityId",
      name: "Activity Details",
      element: <ActivityDetailView />,
      route: PrivateRoute,
    },
    {
      path: "/security/blocked-requests",
      name: "Blocked Requests",
      element: <BlockedRequestsView />,
      route: PrivateRoute,
    },
    {
      path: "/security/modified-responses",
      name: "Modified Responses",
      element: <ModifiedResponsesView />,
      route: PrivateRoute,
    },
    {
      path: "/security/high-risk-activities",
      name: "High Risk Activities",
      element: <HighRiskActivitiesView />,
      route: PrivateRoute,
    },
    {
      path: "/security/users/:userId",
      name: "User Security Profile",
      element: <UserSecurityProfileView />,
      route: PrivateRoute,
    },
    {
      path: "/security/sessions/:sessionId",
      name: "Session Activity",
      element: <SessionActivityView />,
      route: PrivateRoute,
    },
    {
      path: "/security/validations/:validationType",
      name: "Validation Details",
      element: <ValidationDetailsView />,
      route: PrivateRoute,
    },
  ],
};

// const calendarAppRoutes: RoutesProps = {
//   path: "/apps/calendar",
//   name: "Calendar",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "calendar",
//   element: <CalendarApp />,
//   header: "Apps",
// };

const chatAppRoutes = {
  path: "/apps/datadiscovery",
  name: "Chat",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ChatApp />,
};
// const chatHistoryRoutes = {
//   path: "/apps/datadiscovery/history",
//   name: "Chat History",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "clock",
//   element: <ChatHistory />,
// };

const chatHubRoutes = {
  path: "/apps/chathub",
  name: "ChatHub",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ChatHub />,
};

const presentationRoutes = {
  path: "/apps/presentation/*",
  name: "Presentation",
  route: Route,
  element: <PresentationApp />,
};

const compliancereportRoutes = {
  path: "/apps/compliance",
  name: "Compliance",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <Compliancereport />,
};
 const sharedChatViewRoutes = {
    path: "/shared/chat/:shareToken",
    name: "Shared Chat",
    element: <SharedChatView />,
    route: PrivateRoute,
  };
  const sharedFolderViewRoutes = {
    path: "/shared/folder/:shareToken",
    name: "Shared Folder",
    element: <SharedFolderView />,
    route: PrivateRoute,
  };
    const sharedWorkspaceViewRoutes = {
    path: "/shared/workspace/:shareToken",
    name: "Shared Workspace",
    element: <SharedWorksapceView />,
    route: PrivateRoute,
  };
const demoChatRoutes = {
  path: "/apps/demochat",
  name: "DemoChat",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DemoChat />,
};
const ChathubHistorySearchRoutes = {
  path: "/apps/chathistory",
  name: "Search Chats",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ChathubHistorySearch />,
};
const aireadyAppRoutes = {
  path: "/aicontroller/aiready",
  name: "Aiready",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <AIreadyApp />,
  children: [
    {
      path: "/aicontroller/aiready",
      name: "Dashboard",
      element: <AIreadyApp />,
      route: PrivateRoute,
    },
    {
      path: "/aicontroller/aiready/category/:database/:schema/:category",
      name: "Category Details",
      element: <CategoryDetailView />,
      route: PrivateRoute,
    },
    {
      path: "/aicontroller/aiready/table/:database/:schema/:table",
      name: "Table Details",
      element: <TableDetailView />,
      route: PrivateRoute,
    },
    {
      path: "/aicontroller/aiready/recommendations/:database/:schema?",
      name: "Recommendations",
      element: <RecommendationsView />,
      route: PrivateRoute,
    },
    {
      path: "/aicontroller/aiready/summary/:database/:schema",
      name: "Executive Summary",
      element: <ExecutiveSummaryView />,
      route: PrivateRoute,
    },
  ],
};

const datacatalogAppRoutes = {
  path: "/apps/governance/assets",
  name: "datacatalog",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DataCatalogApp />,
};
const dataqualityAppRoutes = {
  path: "/dataquality/overview",
  name: "dataquality",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DataqualityApp />,
};
const classificationAppRoutes = {
  path: "/apps/governance/admin/classification",
  name: "classification",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ClassificationApp />,
};
const questionAppRoutes = {
  path: "/apps/governance/admin/questions",
  name: "question",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <QuestionApp />,
};
const personasAppRoutes = {
  path: "/apps/governance/admin/personas",
  name: "personas",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <PersonasApp />,
};
const domainAppRoutes = {
  path: "/apps/governance/admin/domains",
  name: "domains",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DomainApp />,
};
const rangerpolicyAppRoutes = {
  path: "/apps/governance/policy",
  name: "policy",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <RangerpolicyApp />,
};
const DataqualityruleAppRoutes = {
  path: "/dataquality/observability",
  name: "dqrules",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DataqualityruleApp />,
};
const glossaryAppRoutes = {
  path: "/apps/governance/glossary",
  name: "glossary",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <GlossaryApp />,
};
const insightAppRoutes = {
  path: "/apps/insight",
  name: "Insight",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <InsightApp />,
};
const billingAppRoutes = {
  path: "/apps/billing",
  name: "Billing",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <BillingApp />,
};
const settingsBillingRoutes = {
  path: "/settings/billing",
  name: "Billing",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <BillingApp />,
};
const myInsightAppRoutes = {
  path: "/apps/myinsight",
  name: "Insight",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <MyInsightApp />,
};
const scheduledTasksAppRoutes = {
  path: "/apps/scheduletasks",
  name: "Scheduled Tasks",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "clock",
  element: <ScheduledTasksApp />,
};
const modelsAppRoutes = {
  path: "/apps/models",
  name: "Models",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ModelsApp />,
};
const aiSecurityAppRoutes = {
  path: "/apps/security/policy",
  name: "Policy",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <AISecurityApp />,
};
const snowflakeFormRoutes = {
  path: "/apps/snowflakeform",
  name: "Snowflake Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <SnowflakeForm />,
};
const postgreSQLFormRoutes = {
  path: "/apps/postgresqlform",
  name: "PostgreSQL Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <PostgresqlForm />,
};
const SQLliteFormRoutes = {
  path: "/apps/sqlliteform",
  name: "SQLLite Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <SQLliteForm />,
};
const BigqueryFormRoutes = {
  path: "/apps/bigqueryform",
  name: "Big Query Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <BigqueryForm />,
};
const SqlserverFormRoutes = {
  path: "/apps/sqlserverform",
  name: "SQL Server Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <SqlserverForm />,
};
const MysqlFormRoutes = {
  path: "/apps/mysqlform",
  name: "MySQL Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <MysqlForm />,
};
const MongodbFormRoutes = {
  path: "/apps/mongodbform",
  name: "MongoDB Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <MongodbForm />,
};
const MicrosoftGraphFormRoutes = {
  path: "/apps/microsoftgraph",
  name: "Microsoft Graph Form",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <MicrosoftgraphForm />,
};
const gptAppRoutes = {
  path: "/settings/llmsetup",
  name: "Gpt",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <GptApp />,
};
const approvedAppsRoutes ={
   path: "/settings/approvedapps",
  name: "Approved Apps",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ApprovedApps />,
};
const NotficationPreferencesRoutes = {
  path: "/settings/notificationpreferences",
  name: "Notification Preference",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <NotificationPreferences />,
};
const keycloakGroupsRoutes = {
  path: "/settings/groups",
  name: "Keycloak",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <KeycloakGroups />,
};
const keycloakUserRoutes = {
  path: "/settings/users",
  name: "Keycloak Users",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "users", // You can replace this with the appropriate icon you want
  element: <KeycloakUser />,
};
const keycloakUserDetailsRoutes = {
  path: "/settings/users/:userId",
  name: "User Details",
  route: PrivateRoute,
  roles: ["Admin"],
  element: <KeycloakUserDetailsWrapper />,
};
const connectdbAppRoutes = {
  path: "/apps/database",
  name: "Chat",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <ConnectdbApp />,
};
const ActivedatasetRoutes = {
  path: "/aicontroller/queryexecutor",
  name: "CurrentDataset",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <Activedataset />,
};
const MetadataappRoutes = {
  path: "/apps/dataset/metadata/:tableName",
  name: "Metadataapp",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <Metadataapp />,
};
const DqruleappRoutes = {
  path: "/apps/dataquality/rulestable/:tableName",
  name: "Dqruletableapp",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DqruleApp />,
};
const DqrulelogappRoutes = {
  path: "/dataquality/ruleslogs",
  name: "DqrulelogdtApp",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DqrulelogApp />,
};
const DatacatalogMetadataappRoutes = {
  path: "/apps/assets/dataprofile/:tableName/:guid",
  name: "Metadataapp",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DatacatalogMetadataapp />,
};
const DomainDetailsappRoutes = {
  path: "/apps/domain/domaindetails/:tableName/:guid",
  name: "DomainDetailsapp",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <DomainDetailsapp />,
};
const AiagentappRoutes = {
  path: "/aicontroller/autonomousagents",
  name: "Aiautoagentapp",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <Aiagentapp />,
};
const AireadydatasetappRoutes = {
  path: "/apps/aiready/aireadydataset/:tableName",
  name: "Aireadydatasetapp",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <Aireadydatasetapp />,
};
const AireadytemplatesRoutes = {
  path: "/aicontroller/templates",
  name: "AireadyTemplates",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "message-square",
  element: <AireadyTemplates />,
};
// const ecommerceAppRoutes = {
//   path: "/apps/ecommerce",
//   name: "eCommerce",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "shopping-cart",
//   children: [
//     {
//       path: "/apps/ecommerce/dashboard",
//       name: "Products",
//       element: <EcommerceDashboard />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/products",
//       name: "Products",
//       element: <EcommerceProducts />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/product-details",
//       name: "Product Details",
//       element: <ProductDetails />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/edit-product",
//       name: "Product Edit",
//       element: <ProductEdit />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/customers",
//       name: "Customers",
//       element: <Customers />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/orders",
//       name: "Orders",
//       element: <Orders />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/order/details",
//       name: "Order Details",
//       element: <OrderDetails />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/sellers",
//       name: "Sellers",
//       element: <Sellers />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/shopping-cart",
//       name: "Shopping Cart",
//       element: <Cart />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/ecommerce/checkout",
//       name: "Checkout",
//       element: <Checkout />,
//       route: PrivateRoute,
//     },
//   ],
// };

// const crmAppRoutes = {
//   path: "/apps/crm",
//   name: "CRM",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "users",
//   children: [
//     {
//       path: "/apps/crm/dashboard",
//       name: "Dashboard",
//       element: <CRMDashboard />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/crm/contacts",
//       name: "Contacts",
//       element: <CRMContacts />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/crm/opportunities",
//       name: "Opportunities",
//       element: <Opportunities />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/crm/leads",
//       name: "Leads",
//       element: <CRMLeads />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/crm/customers",
//       name: "Customers",
//       element: <CRMCustomers />,
//       route: PrivateRoute,
//     },
//   ],
// };

// const emailAppRoutes = {
//   path: "/apps/email",
//   name: "Email",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "mail",
//   children: [
//     {
//       path: "/apps/email/inbox",
//       name: "Inbox",
//       element: <Inbox />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/email/details",
//       name: "Email Details",
//       element: <EmailDetail />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/email/compose",
//       name: "Compose Email",
//       element: <EmailCompose />,
//       route: PrivateRoute,
//     },
//   ],
// };

// const socialAppRoutes = {
//   path: "/apps/social-feed",
//   name: "Social Feed",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "rss",
//   element: <SocialFeed />,
// };

const companiesAppRoutes = {
  path: "/apps/connectors",
  name: "Companies",
  route: PrivateRoute,
  roles: ["Admin"],
  icon: "activity",
  element: <Companies />,
};

// const projectAppRoutes = {
//   path: "/apps/projects",
//   name: "Projects",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "uil-briefcase",

//   children: [
//     {
//       path: "/apps/projects/list",
//       name: "List",
//       element: <Projects />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/projects/:id/details",
//       name: "Detail",
//       element: <ProjectDetail />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/projects/create",
//       name: "Create Project",
//       element: <ProjectForm />,
//       route: PrivateRoute,
//     },
//   ],
// };

// const taskAppRoutes = {
//   path: "/apps/tasks",
//   name: "Tasks",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "clipboard",
//   children: [
//     {
//       path: "/apps/tasks/list",
//       name: "Task List",
//       element: <TaskList />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/tasks/details",
//       name: "Task List",
//       element: <TaskDetails />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/tasks/kanban",
//       name: "Kanban",
//       element: <Kanban />,
//       route: PrivateRoute,
//     },
//   ],
// };

// const contactsRoutes = {
//   path: "/apps/contacts",
//   name: "Contacts",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "book",
//   children: [
//     {
//       path: "/apps/contacts/list",
//       name: "Task List",
//       element: <ContactsList />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/contacts/profile",
//       name: "Profile",
//       element: <ContactsProfile />,
//       route: PrivateRoute,
//     },
//   ],
// };

// const ticketsRoutes = {
//   path: "/apps/tickets",
//   name: "Tickets",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "aperture",
//   children: [
//     {
//       path: "/apps/tickets/list",
//       name: "List",
//       element: <TicketsList />,
//       route: PrivateRoute,
//     },
//     {
//       path: "/apps/tickets/details",
//       name: "Details",
//       element: <TicketsDetails />,
//       route: PrivateRoute,
//     },
//   ],
// };

// const fileAppRoutes = {
//   path: "/apps/file-manager",
//   name: "File Manager",
//   route: PrivateRoute,
//   roles: ["Admin"],
//   icon: "folder-plus",
//   element: <FileManager />,
// };

const monitoringRoutes = {
  path: "/apps/monitoring",
  name: "Monitoring",
  element: <Navigate to="/dashboard-1" />, // Redirect Monitoring to Dashboard-1
  route: PrivateRoute,
};


const appRoutes = [
  securityRoutes,
  //calendarAppRoutes,
  chatAppRoutes,
 // chatHistoryRoutes,
  chatHubRoutes,
  compliancereportRoutes,
  sharedChatViewRoutes,
  sharedFolderViewRoutes,
  sharedWorkspaceViewRoutes,
  demoChatRoutes,
  ChathubHistorySearchRoutes,
  aireadyAppRoutes,
  datacatalogAppRoutes,
  dataqualityAppRoutes,
  classificationAppRoutes,
  questionAppRoutes,
  personasAppRoutes,
  domainAppRoutes,
  rangerpolicyAppRoutes,
  DataqualityruleAppRoutes,
  glossaryAppRoutes,
  insightAppRoutes,
  billingAppRoutes,
  settingsBillingRoutes,
  myInsightAppRoutes,
  scheduledTasksAppRoutes,
  modelsAppRoutes,
  aiSecurityAppRoutes,
  gptAppRoutes,
  approvedAppsRoutes,
  NotficationPreferencesRoutes,
  keycloakGroupsRoutes,
  keycloakUserRoutes,
  keycloakUserDetailsRoutes,
  snowflakeFormRoutes,
  postgreSQLFormRoutes,
  SQLliteFormRoutes,
  BigqueryFormRoutes,
  SqlserverFormRoutes,
  MysqlFormRoutes,
  MongodbFormRoutes,
  MicrosoftGraphFormRoutes,
  connectdbAppRoutes,
  ActivedatasetRoutes,
  MetadataappRoutes,
  DqruleappRoutes,
  DqrulelogappRoutes,
  DatacatalogMetadataappRoutes,
  DomainDetailsappRoutes,
  AireadydatasetappRoutes,
  AireadytemplatesRoutes,
  AiagentappRoutes,
  companiesAppRoutes,
  // ecommerceAppRoutes,
  // crmAppRoutes,
  // emailAppRoutes,
  // socialAppRoutes,
  
  // projectAppRoutes,
  // taskAppRoutes,
  // contactsRoutes,
  // ticketsRoutes,
  // fileAppRoutes,
  monitoringRoutes,
];

// pages
const extrapagesRoutes = {
  path: "/pages",
  name: "Pages",
  icon: "package",
  header: "Custom",
  children: [
    // {
    //   path: "/pages/starter",
    //   name: "Starter",
    //   element: <Starter />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/pages/timeline",
    //   name: "Timeline",
    //   element: <Timeline />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/pages/sitemap",
    //   name: "Sitemap",
    //   element: <Sitemap />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/pages/invoice",
    //   name: "Invoice",
    //   element: <Invoice />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/pages/faq",
    //   name: "FAQ",
    //   element: <FAQ />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/pages/serach-results",
    //   name: "Search Results",
    //   element: <SearchResults />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/pages/pricing",
    //   name: "Pricing",
    //   element: <Pricing />,
    //   route: PrivateRoute,
    // },
    // {
    //   path: "/pages/gallery",
    //   name: "Gallery",
    //   element: <Gallery />,
    //   route: PrivateRoute,
    // },
    {
      path: "/pages/error-404-alt",
      name: "Error - 404-alt",
      element: <Error404Alt />,
      route: PrivateRoute,
    },
  ],
};

// ui
const uiRoutes = {
  path: "/ui",
  name: "Components",
  icon: "pocket",
  header: "UI Elements",
  children: [
    {
      path: "/ui/base",
      name: "Base UI",
      children: [
        // {
        //   path: "/ui/buttons",
        //   name: "Buttons",
        //   element: <Buttons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/cards",
        //   name: "Cards",
        //   element: <Cards />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/avatars",
        //   name: "Avatars",
        //   element: <Avatars />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/portlets",
        //   name: "Portlets",
        //   element: <Portlets />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/tabs-accordions",
        //   name: "Tabs & Accordions",
        //   element: <TabsAccordions />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/progress",
        //   name: "Progress",
        //   element: <Progress />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/modals",
        //   name: "Modals",
        //   element: <Modals />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/notifications",
        //   name: "Notifications",
        //   element: <Notifications />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/offcanvas",
        //   name: "Offcanvas",
        //   element: <Offcanvases />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/placeholders",
        //   name: "Placeholders",
        //   element: <Placeholders />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/spinners",
        //   name: "Spinners",
        //   element: <Spinners />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/images",
        //   name: "Images",
        //   element: <Images />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/carousel",
        //   name: "Carousel",
        //   element: <Carousels />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/listgroups",
        //   name: "List Groups",
        //   element: <ListGroups />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/embedvideo",
        //   name: "EmbedVideo",
        //   element: <EmbedVideo />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/dropdowns",
        //   name: "Dropdowns",
        //   element: <Dropdowns />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/ribbons",
        //   name: "Ribbons",
        //   element: <Ribbons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/tooltips-popovers",
        //   name: "Tooltips & Popovers",
        //   element: <TooltipsPopovers />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/typography",
        //   name: "Typography",
        //   element: <Typography />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/grid",
        //   name: "Grid",
        //   element: <Grid />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/general",
        //   name: "General UI",
        //   element: <GeneralUI />,
        //   route: PrivateRoute,
        // },
      ],
    },
    {
      path: "/ui/extended",
      name: "Extended UI",
      children: [
        // {
        //   path: "/extended-ui/nestable",
        //   name: "Nestable List",
        //   element: <NestableList />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/extended-ui/dragdrop",
        //   name: "Drag and Drop",
        //   element: <DragDrop />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/extended-ui/rangesliders",
        //   name: "Range Sliders",
        //   element: <RangeSliders />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/extended-ui/animation",
        //   name: "Animation",
        //   element: <Animation />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/extended-ui/sweet-alert",
        //   name: "Sweet Alert",
        //   element: <SweetAlerts />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/extended-ui/tour",
        //   name: "Tour Page",
        //   element: <TourPage />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/extended-ui/loading-buttons",
        //   name: "Loading Buttons",
        //   element: <LoadingButtons />,
        //   route: PrivateRoute,
        // },
      ],
    },
    // {
    //   path: "/ui/widgets",
    //   name: "Widgets",
    //   element: <Widgets />,
    //   route: PrivateRoute,
    // },
    {
      path: "/ui/icons",
      name: "Icons",
      children: [
        // {
        //   path: "/ui/icons/two-tone",
        //   name: "Two Tone Icons",
        //   element: <TwoToneIcons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/icons/feather",
        //   name: "Feather Icons",
        //   element: <FeatherIcons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/icons/dripicons",
        //   name: "Dripicons",
        //   element: <Dripicons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/icons/mdi",
        //   name: "Material Design",
        //   element: <MDIIcons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/icons/font-awesome",
        //   name: "Font Awesome 5",
        //   element: <FontAwesomeIcons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/icons/themify",
        //   name: "Themify",
        //   element: <ThemifyIcons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/icons/simple-line",
        //   name: "Simple Line Icons",
        //   element: <SimpleLineIcons />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/icons/weather",
        //   name: "Weather Icons",
        //   element: <WeatherIcons />,
        //   route: PrivateRoute,
        // },
      ],
    },
   
    {
      path: "/ui/tables",
      name: "Tables",
      children: [
        // {
        //   path: "/ui/tables/basic",
        //   name: "Basic",
        //   element: <BasicTables />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/tables/advanced",
        //   name: "Advanced",
        //   element: <AdvancedTables />,
        //   route: PrivateRoute,
        // },
      ],
    },
    {
      path: "/ui/charts",
      name: "Charts",
      children: [
        // {
        //   path: "/ui/charts/apex",
        //   name: "Apex",
        //   element: <ApexChart />,
        //   route: PrivateRoute,
        // },
        // {
        //   path: "/ui/charts/chartjs",
        //   name: "Chartjs",
        //   element: <ChartJs />,
        //   route: PrivateRoute,
        // },
      ],
    },
    
  ],
};

// auth
const authRoutes: RoutesProps[] = [
  {
    path: "/auth/login",
    name: "Login",
    element: <Login />,
    route: Route,
  },
  {
    path: "/auth/register",
    name: "Register",
    element: <Register />,
    route: Route,
  },
  {
    path: "/auth/confirm",
    name: "Confirm",
    element: <Confirm />,
    route: Route,
  },
  {
    path: "/auth/forget-password",
    name: "Forget Password",
    element: <ForgetPassword />,
    route: Route,
  },
  {
    path: "/auth/signin-signup",
    name: "SignIn-SignUp",
    element: <SignInSignUp />,
    route: Route,
  },
  {
    path: "/auth/lock-screen",
    name: "Lock Screen",
    element: <LockScreen />,
    route: Route,
  },
  {
    path: "/auth/logout",
    name: "Logout",
    element: <Logout />,
    route: Route,
  },
  {
    path: "/auth/reset-temp-password",
    name: "Reset Temporary Password",
    element: <ResetTempPassword />,
    route: Route,
  },
  {
    path: "/auth/change-password",
    name: "Change Password",
    element: <ChangePassword />,
    route: PrivateRoute,
  },
  // {
  //   path: "/auth/login2",
  //   name: "Login2",
  //   element: <Login2 />,
  //   route: Route,
  // },
  // {
  //   path: "/auth/logout2",
  //   name: "Logout2",
  //   element: <Logout2 />,
  //   route: Route,
  // },
  // {
  //   path: "/auth/register2",
  //   name: "Register2",
  //   element: <Register2 />,
  //   route: Route,
  // },
  // {
  //   path: "/auth/confirm2",
  //   name: "Confirm2",
  //   element: <Confirm2 />,
  //   route: Route,
  // },
  // {
  //   path: "/auth/forget-password2",
  //   name: "Forget Password2",
  //   element: <ForgetPassword2 />,
  //   route: Route,
  // },
  // {
  //   path: "/auth/signin-signup2",
  //   name: "SignIn-SignUp2",
  //   element: <SignInSignUp2 />,
  //   route: Route,
  // },
  // {
  //   path: "/auth/lock-screen2",
  //   name: "Lock Screen2",
  //   element: <LockScreen2 />,
  //   route: Route,
  // },
];

// public routes
const otherPublicRoutes = [
  presentationRoutes,
  // {
  //   path: "/landing",
  //   name: "landing",
  //   element: <Landing />,
  //   route: Route,
  // },
  // {
  //   path: "/maintenance",
  //   name: "Maintenance",
  //   element: <Maintenance />,
  //   route: Route,
  // },
  {
    path: "/error-404",
    name: "Error - 404",
    element: <Error404 />,
    route: Route,
  },
  {
    path: "/error-404-two",
    name: "Error - 404 Two",
    element: <Error404Two />,
    route: Route,
  },
  {
    path: "/error-500",
    name: "Error - 500",
    element: <Error500 />,
    route: Route,
  },
  {
    path: "/error-500-two",
    name: "Error - 500 Two",
    element: <Error500Two />,
    route: Route,
  },
  // {
  //   path: "/upcoming",
  //   name: "Coming Soon",
  //   element: <Upcoming />,
  //   route: Route,
  // },
];

// flatten the list of all nested routes
const flattenRoutes = (routes: RoutesProps[]) => {
  let flatRoutes: RoutesProps[] = [];

  routes = routes || [];
  routes.forEach((item: RoutesProps) => {
    flatRoutes.push(item);

    if (typeof item.children !== "undefined") {
      flatRoutes = [...flatRoutes, ...flattenRoutes(item.children)];
    }
  });
  return flatRoutes;
};

// All routes
const authProtectedRoutes = [
  rootRoute,
  dashboardRoutes,
  ...appRoutes,
  extrapagesRoutes,
  uiRoutes,
];
const publicRoutes = [...authRoutes, ...otherPublicRoutes];

const authProtectedFlattenRoutes = flattenRoutes([...authProtectedRoutes]);
const publicProtectedFlattenRoutes = flattenRoutes([...publicRoutes]);
export {
  publicRoutes,
  authProtectedRoutes,
  authProtectedFlattenRoutes,
  publicProtectedFlattenRoutes,
};
